import React from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon } from 'lucide-react';
export function Offer() {
  return <section id="oferta" className="w-full bg-navy-900 px-4 py-20 scroll-mt-8" data-id="element-104">
      <div className="max-w-5xl mx-auto" data-id="element-105">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-106">
          <h2 className="font-serif text-3xl md:text-4xl text-white mb-4" data-id="element-107">
            Recupera Tus Noches y Tu Salud Hoy Mismo
          </h2>
          <div className="h-1 w-24 bg-gold mx-auto mb-6" data-id="element-108"></div>
          <p className="text-gray-300 text-lg" data-id="element-109">
            Por menos de lo que cuesta una caja de somníferos químicos, tendrás
            una herramienta para toda la vida.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-110">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="flex justify-center" data-id="element-111">
            <img src="https://cdn.magicpatterns.com/uploads/eQw2E1bJPnFm8dfpxNRBr7/insonio_chino.png" alt="Protocolo SOS: Insomnio Chino" className="w-full max-w-sm rounded-lg shadow-2xl" data-id="element-112" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="text-center md:text-left" data-id="element-113">
            <div className="bg-navy-800 border-2 border-gold rounded-lg p-8 mb-6" data-id="element-114">
              <p className="text-gray-400 text-sm mb-2" data-id="element-115">
                Obtén el Protocolo SOS: Insomnio Chino por solo
              </p>
              <div className="flex items-baseline justify-center md:justify-start gap-3 mb-4" data-id="element-116">
                <span className="font-serif text-2xl text-gray-500 line-through" data-id="element-117">
                  $15.00
                </span>
                <span className="font-serif text-6xl text-gold font-bold" data-id="element-118">
                  $6.99
                </span>
              </div>
              <div className="flex items-center gap-2 text-gray-300 mb-6" data-id="element-119">
                <DownloadIcon className="w-5 h-5 text-gold" data-id="element-120" />
                <span className="text-sm" data-id="element-121">
                  Descarga inmediata en PDF para que puedas usarlo esta misma
                  noche
                </span>
              </div>
            </div>

            <motion.a href="https://bienestarypaz.com//cart/46742562406556:1" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.05,
            boxShadow: '0 0 30px rgba(212, 175, 55, 0.5)'
          }} whileTap={{
            scale: 0.95
          }} className="block w-full bg-gold text-navy-900 font-bold px-8 py-5 rounded-lg text-xl transition-all duration-300 text-center cursor-pointer" data-id="element-122">
              ¡QUIERO DORMIR BIEN AHORA!
            </motion.a>
          </motion.div>
        </div>
      </div>
    </section>;
}